import { useTranslation } from 'react-i18next'
import { UserAvatar } from './UserAvatar'
import type { LeaderboardEntry } from '../types'

interface LeaderboardRowProps {
  readonly entry: LeaderboardEntry
}

/** Les trois premiers rangs portent une médaille, les suivants leur numéro. */
const MEDALS: Record<number, string> = { 1: '🥇', 2: '🥈', 3: '🥉' }

export function LeaderboardRow({ entry }: LeaderboardRowProps) {
  const { t } = useTranslation()

  return (
    <li
      className={[
        'flex items-center gap-3 rounded-2xl px-4 py-3',
        entry.is_me ? 'border border-primary bg-primary/5' : 'bg-surface-low',
      ].join(' ')}
    >
      <span
        aria-label={t('social.leaderboard.rank', { rank: entry.rank })}
        className="w-8 shrink-0 text-center font-display text-sm font-bold tabular-nums text-on-surface-variant"
      >
        {MEDALS[entry.rank] ?? entry.rank}
      </span>

      <UserAvatar username={entry.username} avatarUrl={entry.avatar_url} size="sm" />

      <span className="flex min-w-0 flex-1 items-center gap-2">
        <span className="truncate text-sm font-semibold text-on-surface">{entry.username}</span>
        {entry.is_me && (
          <span className="shrink-0 rounded-full bg-primary px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">
            {t('social.leaderboard.you')}
          </span>
        )}
      </span>

      <span className="font-display text-sm font-bold tabular-nums text-secondary">
        {t('social.leaderboard.xp', { xp: entry.xp_total })}
      </span>
    </li>
  )
}
